import { render } from "./dataStatistics.vue?vue&type=template&id=6b5c1a2a&scoped=true"
import script from "./dataStatistics.vue?vue&type=script&lang=js"
export * from "./dataStatistics.vue?vue&type=script&lang=js"

import "./dataStatistics.vue?vue&type=style&index=0&id=6b5c1a2a&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5c1a2a"]])

export default __exports__